const {version} = require('../../package.json'); //eslint-disable-line
// do not use import here
export {version};
export const authResponseProperty = 'RCAuthorizationResponse';
